import { Component, OnInit} from '@angular/core';

import { LoadingGlobalService } from './loading-global.service';

@Component({
    selector: 'app-loading-global',
    templateUrl: './loading-global.component.html',
    styleUrls: ['./loading-global.component.scss'],
})
export class LoadingGlobalComponent implements OnInit {

    public show = false;

    constructor(private loaderService: LoadingGlobalService) {}

    ngOnInit() {
        this.loaderService.status.subscribe((val: boolean) => {
            this.show = val;
        });
    }
}
